import { useState, useCallback, useMemo } from 'react';
import { QueryKey, useQueryClient } from 'react-query';
import { Paginator, Message } from '@twilio/conversations';

const usePrependItems = ({
    messagesCount,
    messagesQueryKey,
}: {
    messagesCount: number;
    messagesQueryKey?: QueryKey;
}) => {
    const queryClient = useQueryClient();
    const [firstItemIndex, setFirstItemIndex] = useState(messagesCount);

    const prependItems = useCallback(async () => {
        if (!messagesQueryKey) return;
        const data = queryClient.getQueryData<Paginator<Message>>(messagesQueryKey);
        if (data?.hasPrevPage) {
            const result = await data.prevPage();
            setFirstItemIndex((prevIndex) => prevIndex - result.items.length);
            queryClient.setQueryData<Paginator<Message> | undefined>(
                messagesQueryKey,
                (oldData) => {
                    if (oldData) {
                        return {
                            ...result,
                            items: [...result.items, ...oldData.items],
                        };
                    }
                    return oldData;
                },
            );
        }
    }, [queryClient, messagesQueryKey]);

    return useMemo(
        () => ({
            prependItems,
            firstItemIndex,
        }),
        [firstItemIndex, prependItems],
    );
};

export default usePrependItems;
